import React, { useState } from "react";
import { Button, Modal, Icon, Dropdown } from "rsuite";
import Formed from "./form";
import { Animation } from "rsuite";
import renderHTML from "react-render-html";
import { deleteTourPackageItinerary } from "../../../../../actions/tourActions";
import { useDispatch } from "react-redux";

const { Fade, Collapse, Transition } = Animation;

function Itinerary(props) {
  const [open, setOpen] = useState(false);
  const [datas, setDatas] = useState(null);
  const onModalOpen = () => setOpen(true);
  const onModalClose = () => setOpen(false);
  const { errorReducer, editCustomer, auth, statuses, tourPackage } = props;
  const onData = (dt) => {
    setDatas(dt);
    setOpen(true);
  };
  const onClear = (dt) => {
    setDatas(null);
    setOpen(false);
  };
  return (
    <div className="">
      <Button onClick={onModalOpen}>Add Itinerary</Button>
      <Modal size="lg" backdrop={'static'} show={open} onHide={onModalClose}>
        <Modal.Header>
          <Modal.Title>Trek Itinerary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formed
            errorReducer={errorReducer}
            close={onClear}
            auth={auth}
            datas={datas}
            isEdit={datas != null}
            editCustomer={editCustomer}
            statuses={statuses}
            tourPackage={tourPackage}
            settings={props.settings}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onModalClose} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {tourPackage?.itineraries &&
        tourPackage?.itineraries.map((it) => {
          return <Iti itinerary={it} onData={onData} />;
        })}
    </div>
  );
}

const Iti = (props) => {
  const { itinerary, onData } = props;
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  return (
    <>
      <div className={`itinerary ${show ? 'itinerary-show' : ''}`} onClick={() => setShow(!show)}>
        <div className="itinerary-container">
          <div className="itinerary-day">Day {itinerary.day}</div>
          <div className="itinerary-title">{itinerary.title}</div>
          <div className="itinerary-actions">
            <div
              onClick={() => onData(itinerary)}
              className="itinerary__edit text-center"
            >
              <Icon icon="edit" size="lg" color="red" />
            </div>
            <div
              onClick={() => setOpen(!open)}
              className="itinerary__delete text-center"
            >
              <Icon icon="minus-square" size="lg" color="blue" />
            </div>
            <Modal
              backdrop="static"
              show={open}
              onHide={() => setOpen(false)}
              size="xs"
            >
              <Modal.Body>
                <Icon
                  icon="remind"
                  style={{
                    color: "#ffb300",
                    fontSize: 24,
                  }}
                />
                {"  "}
                Are you sure, You want to delete this itinerary ?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => {
                    dispatch(deleteTourPackageItinerary(itinerary.id));
                    setOpen(false);
                  }}
                  appearance="primary"
                >
                  Ok
                </Button>
                <Button onClick={() => setOpen(false)} appearance="subtle">
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
        <Collapse in={show}>
          {(props, ref) => <Panel itinerary={itinerary} show={show} {...props} ref={ref} />}
        </Collapse>
      </div>
    </>
  );
};

const Panel = React.forwardRef(({ ...props }, ref) => {
  const { itinerary, show, ...rest } = props;
  return (
    <div
      {...rest}
      ref={ref}
      className={`itinerary-details ${rest.className}`}
      // dangerouslySetInnerHTML={{__html:itinerary?.details}}
    >
      {/* {} */}
      {renderHTML(renderHTML(itinerary?.details))}
    </div>
  );
});

export default Itinerary;
